import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { colors } from '../../styles/constants';
import { roundShadowBoxStyle } from '../RoundShadowBox';
import { generalTablePropTypes } from '.';

const Container = styled.div`
  ${roundShadowBoxStyle}
  ${tw`hidden md:flex p-abs1 overflow-x-scroll mb-abs4`};
`;

const Table = styled.table`
  ${tw`w-full`};
  border-collapse: collapse;
`;

const Caption = styled.caption`
  ${tw`hidden`};
`;

const THead = styled.thead`
  border-bottom: 1px solid ${colors.grey200};
`;

const TH = styled.th`
  ${tw`whitespace-no-wrap`};
  padding: 1rem;
`;

const TD = styled.td`
  ${tw`text-center`};
  padding: 1rem;
`;

const TableHorizontal = ({ caption, data }) => (
  <Container>
    <Table>
      <Caption>{caption}</Caption>
      <THead>
        <tr>
          {data.map((row) => (
            <TH key={`th${row.id}`}>{row.header}</TH>
          ))}
        </tr>
      </THead>
      <tbody>
        <tr>
          {data.map((row) => (
            <TD key={`td${row.id}`}>{row.value}</TD>
          ))}
        </tr>
      </tbody>
    </Table>
  </Container>
);

TableHorizontal.propTypes = {
  caption: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  data: generalTablePropTypes,
};

export { generalTablePropTypes, TableHorizontal };
